import { Component } from '@angular/core';
import { DatepickerComponent } from '@fgpp-ui/components';
import dayjs from 'dayjs';
import { MIN_MAX_DATE_FORMAT } from '../../../core/consts/general.const';
import { IValueChange } from '../../../core/interfaces/form-value-change.interface';
import { BFBeforeProfileCreate, BFBeforeProfileSaveAs, BFOnValueChange } from '../../../core/interfaces/sdk-profile-hooks.interface';
import { ProfileFormTemplateProviders } from '../../../core/templates/profile-form.template.providers';
import { AbstractProfileFormComponent } from '../../abstract/abstract-profile/abstract-profile-form.component';
import { SwiftRMA } from '../../models/swift-rma.model';

@Component({
  selector: 'app-swift-rma',
  templateUrl: '../../../core/templates/profile-form.template.html',
  styleUrls: ['../../../core/templates/profile-form.template.scss'],
  providers: [ProfileFormTemplateProviders]
})
export class SwiftRMAComponent extends AbstractProfileFormComponent implements BFBeforeProfileCreate, BFBeforeProfileSaveAs, BFOnValueChange {

  private readonly BICLength = 8;

  fgppBeforeCreate(): void {
    this.showBICControls();
  }

  fgppBeforeSaveAs(): void {
    this.showBICControls();
  }

  fgppValueChanges(change: IValueChange): void {
    switch (change.control) {
      case SwiftRMA.V_CORRESPONDENT_BIC:
        this.populateBICRelatedControl(SwiftRMA.V_CORRESPONDENT_BIC, SwiftRMA.CORRESPONDENT);
        break;
      case SwiftRMA.V_ISSUER_BIC:
        this.populateBICRelatedControl(SwiftRMA.V_ISSUER_BIC, SwiftRMA.ISSUER);
        break;
      case SwiftRMA.START_DATE:
        this.updateEndDateMinValue(change.value.inputValue);
        break;
      case SwiftRMA.INCLUDED_MSG_CATEGORIES:
        this.resetMessageTypesControls();
        break;
    }
  }

  private showBICControls(): void {
    this.formMgr.get(SwiftRMA.V_CORRESPONDENT_BIC).show();
    this.formMgr.get(SwiftRMA.V_ISSUER_BIC).show();
  }

  private populateBICRelatedControl(BICControlId: SwiftRMA, relatedControlId: SwiftRMA): void {
    const BICValue = this.formMgr.get(BICControlId).getValue();
    const relatedControlValue = BICValue ? BICValue.substring(0, this.BICLength) : '';
    this.formMgr.get(relatedControlId).setValue(relatedControlValue);
  }

  private updateEndDateMinValue(value: string): void {
    const endDateComponent = this.formMgr.get(SwiftRMA.END_DATE).getLayoutControl() as DatepickerComponent;
    if (value) {
      const startDate = dayjs(+value).format(MIN_MAX_DATE_FORMAT);
      endDateComponent.controlData.minDate = startDate;
    } else {
      endDateComponent.controlData.minDate = null;
    }
    endDateComponent.controller.updateValueAndValidity();
  }

  private resetMessageTypesControls(): void {
    this.formMgr.get(SwiftRMA.INCLUDED_SPECIFIC_MTS).setValue('');
    this.formMgr.get(SwiftRMA.EXCLUDED_SPECIFIC_MTS).setValue('');
  }

}
